const PropTypes = require('prop-types');
//@vendor
const React = require('react');
//@commons
const { formatText } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
// @ components
import KitsSummary from 'components/myProfile/myProfileSecurityKitChange/kitsSummary/kitsSummary';

class MyProfileSecurityKitChangeSuccessEnd extends React.PureComponent {
    render () {
        const { sets, referenceKits } = this.props
        const exitLink = `/myProfile`;
        const goBackButtonLabel = formatText('securityKit-successLink').toUpperCase();
        const title = formatText('securityKit-successTitle');
        const goBackButton = {
            label: goBackButtonLabel,
            url: exitLink
        }
        return(
            <WizardSuccess
                successMessage={title}
                mainButton={goBackButton}
            >
                <h4>{formatText('securityKit-infoTextSecurityKitChangeSuccessEnd')}</h4>
                <KitsSummary
                    border={false}
                    sets={sets}
                    referenceKits={referenceKits}
                    fromSubmit
                />

            </WizardSuccess>
        )
    }
}

MyProfileSecurityKitChangeSuccessEnd.propTypes = {
    sets: PropTypes.object.isRequired,
    referenceKits: PropTypes.object.isRequired
}

module.exports = MyProfileSecurityKitChangeSuccessEnd;
